<template lang="pug">
  b-modal#reviewReply(
  ref="reviewReply"
  :title="$t('ui.reply_review')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.member_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="member_id"
          required
          type="text"
          :dirty="$v.member_id.$dirty"
          :error="$v.member_id.$error"
          v-model.trim.lazy="$v.member_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.member_id" :name="$t('ui.member_id')")
      //- b-form-group(:label="$t('ui.recipient_no')" disabled).mb-0
      //-   DebounceInput(
      //-     size="sm"
      //-     ref="recipient_no"
      //-     type="text"
      //-     :dirty="$v.recipient_no.$dirty"
      //-     :error="$v.recipient_no.$error"
      //-     v-model.trim.lazy="$v.recipient_no.$model"
      //-     :disabled="loading"
      //-   )
      //-   ValidateResult(:value="$v.recipient_no" :name="$t('ui.recipient_no')")
      b-form-group(:label="$t('ui.comment')" disabled).mb-0
        b-form-textarea(
          ref="comment"
          v-model="comment"
          :disabled="loading"
          rows="3"
        )
      b-form-group(:label="$t('ui.reply')").mb-0
        b-form-textarea(
          ref="reply"
          type="text"
          :dirty="$v.reply.$dirty"
          :error="$v.reply.$error"
          v-model.trim.lazy="$v.reply.$model"
          :disabled="loading"
          rows="3"
        )
        ValidateResult(:value="$v.reply" :name="$t('ui.reply')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      member_id: "",
      recipient_no: "",
      comment: "",
      reply: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    member_id: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    // recipient_no: {
    //   numeric
    // },
    reply: {
      required,
      maxLength: maxLength(200)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.reviewReplyUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          review_id: this.item.id,
          reply: this.reply,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.reviewReply.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "reply_review", this.feedback.status);
                  this.$refs.reviewReply.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.member_id = this.item.member_id;
      this.recipient_no = this.item.recipient_no;
      this.comment = this.item.comment;
      this.reply = this.item.reply;
      this.$refs.reply.$el.focus();
    }
  }
};
</script>
